import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const legal = [
  ["Terms of Service", "/legal/terms"],
  ["Privacy Policy", "/legal/privacy"],
  ["Candidate Privacy", "/legal/candidate-privacy"],
  ["Immigration Disclaimer", "/legal/immigration"],
  ["AI Transparency", "/legal/ai-transparency"],
  ["Lifetime Access Terms", "/legal/lifetime"],
];

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-surface">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-4 text-sm text-muted max-w-sm leading-relaxed">
            Assemble the technical team your startup was meant to have. Exceptional engineers and
            researchers, discovered through evidence—not résumé keywords.
          </p>
          <p className="mt-4 label-mono text-faint">teamassembly.io</p>
        </div>
        <div className="md:col-span-3">
          <p className="label-mono text-faint mb-4">Platform</p>
          <ul className="space-y-2.5 text-sm text-muted">
            <li><Link to="/register?role=startup_employer" className="hover:text-ink transition-colors duration-200">For Startups</Link></li>
            <li><Link to="/register?role=candidate" className="hover:text-ink transition-colors duration-200">Apply as Talent</Link></li>
            <li><Link to="/pricing" className="hover:text-ink transition-colors duration-200">Pricing</Link></li>
            <li><Link to="/mobility" className="hover:text-ink transition-colors duration-200">Global Mobility</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="label-mono text-faint mb-4">Legal & Trust</p>
          <ul className="grid grid-cols-2 gap-2.5 text-sm text-muted">
            {legal.map(([label, to]) => (
              <li key={to}><Link to={to} className="hover:text-ink transition-colors duration-200">{label}</Link></li>
            ))}
          </ul>
          <div className="mt-6 not-italic text-sm text-muted leading-relaxed" data-testid="footer-contact">
            <p className="text-ink font-medium">Talent Junction, Inc.</p>
            <p>169 Madison Avenue</p>
            <p>New York, NY 10016</p>
            <a href="mailto:contact@teamassembly.io" className="mt-1 inline-block text-azure hover:text-ink transition-colors duration-200">contact@teamassembly.io</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-5 lg:px-8 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-faint">Team Assembly is a software product owned and operated by Talent Junction, Inc. · © 2026 Talent Junction, Inc. · 169 Madison Avenue, New York, NY 10016</p>
        <p className="text-xs text-faint">AI-assisted decision support — human review always required.</p>
      </div>
    </footer>
  );
}
